/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import type TypeForm from 'forms/_.extend';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerWarnings from 'views/ActionDrawer/components/ActionDrawerWarnings/ActionDrawerWarnings';

import styles from '../../../../ActionDrawer.module.scss';
import Loading from '../../../../../../components/Loading/Loading';
import { Carousel } from '../../../../components/Carousel/Carousel';

type TypeProps = {|
  assets: Array,
  form: TypeForm,
|} & TranslatorProps;

@translate()
@inject('assetStore')
@observer
export default class AllocateAssetToProjectForm extends React.Component<*> {
  renderAssetBlock(asset) {
    const { t, assetStore } = this.props;
    const assetDetails = asset.account
      ? asset
      : assetStore.assets.filter(item => item.id === asset.id)[0];

    const assetInfo = [
      [
        t('general:trading_account'),
        assetDetails.account && `${assetDetails.account.name} ${assetDetails.account.number}`,
      ],
      [t('general:assets.labels.number'), assetDetails.asset_number],
      [t('general:manufacturer'), assetDetails.manufacturer],
      [t('general:model'), assetDetails.model],
      [t('general:labels.serial_number'), assetDetails.serial_number],
    ];

    return <ActionDrawerTable data={assetInfo} />;
  }

  renderCarousel() {
    const { t, assetStore, assets, form } = this.props;

    return (
      <ActionDrawerBlock
        divider={false}
        gutters={true}
        heading={t('general:assets.labels.details')}
      >
        <Carousel className={styles['carousel']}>
          {assets.map(assetItem => {
            const assetUser = assetStore.assets.filter(item => item.id === assetItem.id)[0].user;
            return (
              <React.Fragment key={assetItem.id}>
                {this.renderAssetBlock(assetItem)}
                {assetUser && assetUser.name && (
                  <ActionDrawerBlock divider={false} gutters={false}>
                    <div>
                      <b>{t('general:assets.currently_assigned_to')}:</b>
                    </div>
                    <ul>
                      <li>{assetUser.name}</li>
                      <li>{`${t('general:roles.labels.current_role')}: ${assetUser.role}`}</li>
                    </ul>
                    <div className={styles['reassign-asset-warning']}>
                      <ActionDrawerWarnings
                        field={form.$(`allocateProjectWarnings.${assetItem.id}`)}
                        warnings={form.$(`allocateProjectWarnings.${assetItem.id}`).extra.warnings}
                      />
                    </div>
                  </ActionDrawerBlock>
                )}
              </React.Fragment>
            );
          })}
        </Carousel>
      </ActionDrawerBlock>
    );
  }

  render() {
    const { t, form, assetStore }: TypeProps = this.props;
    const projectStatus: string = encodeURIComponent('status:Active|Scheduled');

    if (assetStore.loadingAssets) {
      return <Loading />;
    }

    const asset = assetStore.assets[0];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          {this.renderCarousel()}
          <ElectroCheckList
            field={form.$('allocateProject.project')}
            type="radio"
            heading={t('general:actions.select_project_to_allocate_asset')}
            endpoint={`drop-downs/accounts/${asset.account.id}/projects?search=${projectStatus}
                            &asset_id=${asset.id}`}
            enableSearch={true}
            searchKeys={['name', 'code']}
            primaryLiteral={(item: Object) => `${item.code} - ${item.name}`}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.allocate_to_project')} />
      </React.Fragment>
    );
  }
}
